import React, { useEffect } from 'react';

import CeremonyCard from './CeremonyCard';


const CeremonyBuilder = (props) => {
    const {
        id,
        setOuterEditing
    } = props;

    const [ceremony, setCeremony] = React.useState(undefined);

    useEffect(() => {
        new Promise((resolve, reject) => {
            let url = `/api/ceremony/${id}`
            fetch(url)
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    setCeremony(result);
                    resolve();
                })
        })
    }, [id]);

    return (
        <div id="ceremony-builder-top" className="ceremony-builder-container">
            {ceremony && ceremony.sections.filter(x => x.skip !== true).map((section, id) => {
                const {
                    bride_first_name,
                    groom_first_name,
                } = ceremony.couple;

                const sectionId = `section-${id}`;

                let sectionName = section.section_name;
                sectionName = sectionName.replace(/\[BRIDE\]/g, bride_first_name);
                sectionName = sectionName.replace(/\[GROOM\]/g, groom_first_name);
                section.section_name = sectionName;
                return (
                    <CeremonyCard key={sectionId} section={section} couple={ceremony.couple} setOuterEditing={setOuterEditing} />
               );
           })}
        </div>
    );
};

export default CeremonyBuilder;
